
$('.js-c-mobile-menu').each(function () {
    const $menu = $(this);
    const $toggler = $('.js-c-mobile-menu-toggler', this);
    let opening = false;
    let opened = false;
    let scrollTop = 0;

    $toggler.on('click', function () {//return;
        opened = App.H.hasClass('_mobile-menu--opened');
        $menu.addClass('_burger-clicked');

        if (!opening) {
            opening = true;

            if (opened) {
                App.H.addClass('_mobile-menu--closing').removeClass('_mobile-menu--opened');
                setTimeout(() => {
                    App.H.removeClass('_mobile-menu--closing _mobile-menu-sublist--opened');
                    $('.js-c-mobile-menu-content-head').show();
                    $('.js-c-mobile-menu-sublist._active', $menu).removeClass('_active');
                    $('.js-c-mobile-user-sublist._active', $menu).removeClass('_active');
                    opening = false;
                    // opened = !opened;
                    window.scrollTo(0,scrollTop);
                }, 300);
            } else {
                scrollTop = window.pageYOffset;
                App.H.addClass('_mobile-menu--opening');
                setTimeout(() => {
                    App.H.addClass('_mobile-menu--opened').removeClass('_mobile-menu--opening');
                    window.scrollTo(0,0);
                    opening = false;
                    // opened = !opened;
                }, 300);
            }
        }
    });

    const $menulist = $('.js-c-mobile-menu-list');
    const $contentHead = $('.js-c-mobile-menu-content-head');
    let sublistopening = false;
    let menulistScrollTop = 0;

    $menu.on('click', '.js-c-mobile-menu-button', function () {
        const $sublist = $(this).siblings('.js-c-mobile-menu-sublist');

        if (!sublistopening) {
            sublistopening = true;

            $sublist.addClass('_active');
            menulistScrollTop = window.pageYOffset;
            App.H.addClass('_mobile-menu-sublist--opening');
            setTimeout(() => {
                $contentHead.hide();
                App.H.addClass('_mobile-menu-sublist--opened').removeClass('_mobile-menu-sublist--opening');
                window.scrollTo(0,0);
                sublistopening = false;
            }, 300);
        }
    });

    $menu.one('click', '.js-c-mobile-menu-button', function () {
        $(this).parent().find('[data-flag]').each(function () {
            $(this).css('background-image', 'url(' + $(this).data('flag') + ')');
        });
    });

    $menu.on('click', '.js-c-mobile-menu-back', function () {
        const $sublist = $menulist.find('.js-c-mobile-menu-sublist._active');
        const $sublistUser = $menulist.find('.js-c-mobile-user-sublist');

        if (!sublistopening) {
            sublistopening = true;

            $sublist.removeClass('_active');
            $sublistUser.removeClass('_active');
            App.H.addClass('_mobile-menu-sublist--closing').removeClass('_mobile-menu-sublist--opened');

            $contentHead.show();
            window.scrollTo(0,menulistScrollTop);
            setTimeout(() => {
                App.H.removeClass('_mobile-menu-sublist--closing');
                sublistopening = false;
                $menu.find('.js-c-header-world-links').hide();
            }, 300);
        }
    });

    $menu.on('click', '.js-c-mobile-user-button', function () {
        const $sublist = $('.js-c-mobile-user-sublist');

        if (!sublistopening) {
            sublistopening = true;

            $sublist.addClass('_active');
            menulistScrollTop = window.pageYOffset;
            App.H.addClass('_mobile-menu-sublist--opening');
            setTimeout(() => {
                $contentHead.hide();
                App.H.addClass('_mobile-menu-sublist--opened').removeClass('_mobile-menu-sublist--opening');
                window.scrollTo(0,0);
                sublistopening = false;
            }, 300);
        }
    });
});

